import React from 'react'
import { useEffect, useRef } from 'react'
// import { GoogleLogin } from '@react-oauth/google';
import { GoogleLogout } from 'react-google-login';
const CLIENT_ID = '290835696452-mtp342vjliooimb3j27v62getpo7fti7.apps.googleusercontent.com';

const loadScript = (src) => new Promise((resolve, reject) => {
    if (document.querySelector(`script[src="${src}"]`)) return resolve()
    const script = document.createElement('script')
    script.src = src
    script.onload = () => resolve()
    script.onerror = (err) => reject(err)
    document.body.appendChild(script)
})

const GoogleAuth = () => {
    const googleButton = useRef(null);
    useEffect(() => {
        const src = 'https://accounts.google.com/gsi/client'
        const id = CLIENT_ID

        loadScript(src)
        .then(() => {
            /*global google*/
            google.accounts.id.initialize({
                client_id: id,
                callback: handleCredentialResponse,
            })
            google.accounts.id.renderButton(
                googleButton.current, 
                { theme: 'outline', size: 'large' } 
            )
        })
        .catch(console.error)

        return () => {
            const scriptTag = document.querySelector(`script[src="${src}"]`)
            if (scriptTag) document.body.removeChild(scriptTag)
        }
    }, [])

    function handleCredentialResponse(response) {
        console.log("Encoded JWT ID token: " + response.credential);
    }

    return (
        <div ref={googleButton}></div>
    )
}

export default GoogleAuth


export function GoogleSDKLogout(){
    const logout = (res) => {
        console.log('success:', res);
    };

    return <GoogleLogout
        clientId={CLIENT_ID}
        buttonText="Logout"
        onLogoutSuccess={logout}
        style={{}}
        >
    </GoogleLogout>
}